import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'select': 'changeCategory'
            }
        }
    }

    changeCategory() {
        this.call('goTo', [this.$('select')[0].querySelector(`option[value="${this.$('select')[0].value}"]`).getAttribute('data-select-category-url'), 'filter'], 'Load')
    }
}
